// WHAT CAN BE CHANGED?
// Put the desired content into the #home-div

<template>
    <div id="home" class="page">
        <BannerSlider />
        <ContentHeader header-title="Welkom bij RTV Parkstad" />
        <p>
        RTV Parkstad is het radio- en TV-station voor Parkstad Limburg. 
        Wij zenden 24 uur per dag en 7 dagen per week programma’s uit op radio en televisie om je een vrolijke dag te bezorgen.<br>
        <br>
        Binnen deze app kun je live luisteren naar de radio, berichten sturen naar de studio en diverse programma's terugkijken.
        Ook vind je er informatie hoe je vrijwilliger kunt worden, kunt adverteren bij RTV Parkstad of hoe je verder in contact met ons kan komen.
        </p>
        <ContentHeader header-title="Winacties" />
        <p>
          <b>Op dit moment zijn er geen lopende winacties!</b>
        </p>
    </div>
</template>

<script>
import BannerSlider from "@/components/BannerSlider";
import ContentHeader from "@/components/ContentHeader";

export default {
    name: "Home",
    components: {
        BannerSlider,
        ContentHeader
    },
    props: {  
    }
};
</script>

<style lang="scss" scoped>
#home {
  margin: auto;
  max-width: 768px;

  p {
    font-family: "Lato";
    font-size: 14px;
    margin-bottom: 28px;
  }
}

/* Smartphones (portrait and landscape) ----------- */

@media only screen and (min-device-width: 320px) and (max-device-width: 599px) {
    #home {

    }
}

/* Tablet (portrait) ----------- */

@media only screen and (min-device-width: 600px) and (max-device-width: 899px) {
    #home {

    }
}

/* Tablet (landscape) ----------- */

@media only screen and (min-device-width: 900px) and (max-device-width: 1199px)  {
    #home {

    }
}

// Desktop versions start here ------------------------------------------------------------------------------------------
/* Desktop ----------- */

@media only screen and (min-device-width: 1200px) and (max-device-width: 1799px)  {
    #home {

    }
}

/* Large desktop ----------- */

@media only screen and (min-device-width: 1800px)  {
    #home {
       
    }
}
</style>